import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import {
  Context,
  Transitions,
  ConfirmResetRestoerMasteryLessonSchema
} from "../../types"
import { getResetClassMasteryLessonsAffectedCountTransition } from "../teacher/transitionalStates/getResetClassMasteryLessonsAffectedCount"

export const openConfirmResetMasteryLesson: StateNodeConfig<
  Context,
  ConfirmResetRestoerMasteryLessonSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    openConfirmResetMasteryLesson: true,
    currentClassMasteryLessonAffectedCount: null
  }),
  exit: assign<Context>({
    openConfirmResetMasteryLesson: false
  }),
  initial: "loading",
  states: {
    loading: {
      ...getResetClassMasteryLessonsAffectedCountTransition
    },
    idle: {
      on: {
        RESET_MASTERY_LESSON: {
          target: "#StudyPlan.teacher_view.reset_mastery_lesson_transition"
        },
        CANCEL: {
          target: "#StudyPlan.teacher_view.idle",
          actions: assign<Context>({
            selectedLessonId: null,
            selectedSectionId: null
          })
        }
      }
    }
  }
}
